import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import common from './en/common.json';


export const defaultNS = 'common';
export const resources = {
    en: {
        common
    }
};

i18next.use(initReactI18next).init({
    lng: 'en',
    fallbackLng: 'en',
    debug: true,
    initImmediate: false,
    ns: ['common'],
    defaultNS,
    resources
});


export default i18next;
